import date from 'quasar/src/utils/date.js';;
import Vue from 'vue';
var formatDate = date.formatDate; // Format a timestamp (in seconds) as a string

Vue.prototype.$dateTime = function (timestamp) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ddd Do MMM YYYY @ H:mm:ss';
  return timestamp ? formatDate(timestamp * 1000, format) : '';
};